import { Location, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { ErrorPageService } from 'src/app/services/error-page/error-page.service';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({

  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  imports: [CommonModule, TranslocoPipe, RouterLink]
})
export class ErrorPageComponent {
  private readonly errorPageService = inject(ErrorPageService);
  private readonly location = inject(Location);
  private readonly themeService = inject(ThemeService);

  isError: Subject<boolean> = this.errorPageService.isError;

  back() {
    this.location.back();
  }

  getTheme() {
    return this.themeService.currentTheme();
  }
}
